import styled, { css } from 'styled-components';

interface ImageUserProps {
    urlPhoto: string;
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 100vh;
    background-color:  ${({ theme }) => theme.background};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 3rem;
`;

export const Content = styled.div`
  background:  ${({ theme }) => theme.backgroundCard};
  height: 500px;
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ProfilePicture = styled.section<ImageUserProps>`
    overflow: hidden;
    box-shadow: 5px 0px 15px 5px rgba(0,0,0,0.25);
    height: 100%;
    width: 45%;

    ${props => props.urlPhoto && css`
        background-image: url(${props.urlPhoto});
        background-size: cover;
        background-position: 50% 50%;
    `}
`;

export const RightContainer = styled.section`
  width: 50%;
  background: red;
`;

